/** A skinnable chip group used inside each bot window. Multi-select by default; single-select picks one
 * (re-tapping the active chip clears it). The skin's own CSS colours `.chip` / `.chip.on`. */
interface ChipsProps {
  options: readonly string[];
  selected: string[];
  onToggle: (value: string) => void;
  ariaLabel: string;
  single?: boolean;
  max?: number;
  disabled?: boolean;
}

export function Chips({ options, selected, onToggle, ariaLabel, single, max, disabled }: ChipsProps) {
  const atCap = max != null && !single && selected.length >= max;
  return (
    <div className="chips" role="group" aria-label={ariaLabel}>
      {options.map((opt) => {
        const on = selected.includes(opt);
        const blocked = disabled || (atCap && !on);
        return (
          <button
            key={opt}
            type="button"
            aria-pressed={on}
            disabled={blocked}
            className={`chip${on ? ' on' : ''}`}
            onClick={() => !disabled && onToggle(opt)}
          >
            {opt}
          </button>
        );
      })}
    </div>
  );
}
